// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    grantId: z.string().min(1).max(128),
    grantModelName: z.string().min(1).max(64).optional(),
    clientId: z.string().min(1).max(2048),
    name: z.string().max(256).nullable().optional(),
    logoUri: z.string().max(2048).nullable().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    grantId: z.string().min(1).max(128),
    grantModelName: z.string().max(64),
    clientId: z.string().min(1).max(2048),
    name: z.string().max(256).nullable(),
    logoUri: z.string().max(2048).nullable(),
    createdAt: z.number(),
});
export const CimdGrantClientSnapshots = Object.freeze({
    table: 'cimd_grant_client_snapshots',
    tableSingular: 'cimd_grant_client_snapshot',
    fields: {
        tenantId: 'tenant_id',
        grantId: 'grant_id',
        grantModelName: 'grant_model_name',
        clientId: 'client_id',
        name: 'name',
        logoUri: 'logo_uri',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'grantId',
        'grantModelName',
        'clientId',
        'name',
        'logoUri',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
